// src/theme.ts
export const theme = {
    colors: {
        background: '#282c34',
        text: '#ffffff',
        primary: '#007bff',
        secondary: '#6c757d'
    }
};
